module.exports = __webpack_public_path__ + "img/e-class2021_930x620-300x208.28a08d44.png";